var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#400207",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.125,
    y: 3.41678,
    width: 30.75,
    height: 32.4583,
    fill: "url(#pattern0_1189_1397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1189_1397",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1189_1397",
    transform: "matrix(0.0111111 0 0 0.0105263 0 0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1189_1397",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFaklEQVR4nO2dXYxdUxSAT6d+2kTTNh6mGMG0aHgQGlKCaBUvKiKp9IFGJMSb+o+/UE8zQkOj1E8xlYjGg4gnRXUoJeOlpUbUvPlJO0x/pqJBfbLMMjm5Ofvcc+7Z5+5z7qwvucnNnTV7/czed6+z9jpnosgwDKMzAa4CXga+Aw7raxh4CVgW2r7aA5wFDNKcbcCZoe2tJcDlwBjZEdnLQttdx5k8Rn5+AxaEtr82AFtpncHQ9tdp4yvKlaH9qDzAK4XDDC+G9qPyMJHCFWU4tB+VBxj3EOjx0H5MlUAfDO3HVPnq+Da0H5WHiUvtomwI7UflAZZ5CPTS0H7UAuCjAkHeFtr+2gCcAYy2EGS7BM+LFIg0cHmCbEWlVpDSJ/BxhiBLbcSKSUWR2oVcVkvapnn2uL6Xz2zjMwzDMAzDqD7AEu3bGNY+Dhf/93hIqndFaLtrAzC/YK3jA7mED+1HpQEuAX6lOFInuTi0P5UEOB3Yhz/kDzY/tF+VA/gQ/2wN7VelAJZSHrZBej6+cmHHWp4PZF3YQa3nFgMXhyYVTXUomdD+VQYs0BbojgKb0RbojgKb0RbojgKb0RbojgKb0RbojgKb0W0L9C8lxvrnNrlRfYC1JQb66dD+VQZgJvAssN9jgPfrmDND+1c5gGlNgvc90KstCT80kZ0WTUWAY4FFwB3AxhS5NNbE5J5IE0wZf6PacIHYFHXI7BRnHgI+BY5kDEQat8Xkbm8x0HH+AD5RG8+v1SoALgJekN3eQyAaWR6TW47/8cXm54ELoyoCzALuAr5u4sgkKWOlMRkAeV/C+HHElzuBE6LQAMfpEs6dB0fuMdM4JSbXU8L4ro6nB4JlL7p0f2rB8P9IGdfFP/HNSzdX+czX+M34Ebi2jFim5bzPpTmZwiFgSzx7yBGIfQmyzps+U8Zfox2nYktexOd1wAyfMU0y8kRgKIdhR4EdwMOagUzPoMPFrgTZXS7hDHqma7r5CPCF2poVkZ9bJJZphs0AvsxoiATgXuCkFvS42JIgK6sjkRb0ngzcl2ND/xw4Pq+eLIbIkmnG+9KpX1CPi4EE2QGXsIemS+cfMcYzRfQkKT6nydLa7esOVtz0J8j2lxHohjt25bYNF38DC33oyjKbB3wuIdyb1OoE2dVl99vpV+YbbZnVet91Epu9KVGAEYeulQmyKx2yI5FngLcdur7xqeR3h5Jeb0oU3dEzNZTLZw7ZHZFntGKYxGGfSg46lJzqTYmiOXpS/tqdINvtyOfXRZ4BTnPE4IBPJa589U3fFS8mqmiyycR5J0X+3QZZ+d3zSqhEvuWIwU6fip7Ezau+80ngVq2kjeqNmrNTZGfrjZ+jWhK4xbMtshm+nuJ/n09lC4G/mpx8TJYwOwXgOmBPit8Sk7N9K32KbBcsVwNdUU0BuoBrtB7SjP6yiklyUpKFPXo5Oy+qCcA84P4MZ5Hxx92XU1ySQkqOegd6NTmk53uLsxSV2oUWlRarbUM5i0pSKJtTtoGyOWyiNca0htAH3ChP9mrHOZ1mDQtUZ59+LbTyaHvhtdLLpA3G31Ck8B/jgKRIwHvAeuBB4Ca9GJEy5rnaYtCtK6pLX3P1s16VWaSPnrhZx1ivY+5MuQ7Ig/h6fdsCnHBW+KjnxpeqMaY161lBgtwQ8DnAPU1SobohKevdaTl8MHRJSy13g+dHQrSLvdoqsaQ2PR66q8uDTh4HPmtsoKkIR9S2x+RBKlXKiloGOEY3rVXafLi9ybOSfPOnHlBs0n6NS9uaPVRg1vfozF+hhXxp4d2s/yPrKw3OiC7rMc13j+r7vfqz3So7qL+7VsdaoWP3dMRsNQzDMAzDMAzDiErgXyaAgh76UXSVAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.689fd3cf84aab73555d83e750c2d4bec.svg";
export { ForwardRef as ReactComponent };